/**
 * @file: StoreFeature.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum StoreFeature {
  OrderReception = 'order-reception',
  PreInspection = 'pre-inspection',
  Inspection = 'inspection',
  Construction = 'construction',
  DeliveryCheck = 'delivery-check',
  SamplingCheck = 'sampling-check',
  Quotation = 'quotation',
  MaintenancePlan = 'maintenance-plan',
  Lead = 'lead',
  Reservation = 'reservation',
  Chat = 'chat',
  ChatBot = 'chat-bot',
  ProductReward = 'product-reward',
  RewardsCampaign = 'rewards-campaign',
  CouponCampaign = 'coupon-campaign',
  Apdm = 'apdm',
  WechatRpa = 'wechat-rpa',
  WeworkRpa = 'wework-rpa',
  MomentPoster = 'moment-poster',
  PosterStudio = 'poster-studio',
  ErpIntegration = 'erp-integration',
  DailyReport = 'daily-report',
  DataReport = 'data-report',
  MpDataDashboard = 'mp-data-dashboard',
  Bi = 'bi',
  WorkbenchWeb = 'workbench-web',
  HubDisplay = 'hub-display',
  AiAssistant = 'ai-assistant',
  Coaching = 'coaching',
  VoiceInput = 'voice-input',
  VoiceSynthesis = 'voice-synthesis',
}

export const StoreFeatureValueSet = new Set([
  StoreFeature.OrderReception,
  StoreFeature.PreInspection,
  StoreFeature.Inspection,
  StoreFeature.Construction,
  StoreFeature.DeliveryCheck,
  StoreFeature.SamplingCheck,
  StoreFeature.Quotation,
  StoreFeature.MaintenancePlan,
  StoreFeature.Lead,
  StoreFeature.Reservation,
  StoreFeature.Chat,
  StoreFeature.ChatBot,
  StoreFeature.ProductReward,
  StoreFeature.RewardsCampaign,
  StoreFeature.CouponCampaign,
  StoreFeature.Apdm,
  StoreFeature.WechatRpa,
  StoreFeature.WeworkRpa,
  StoreFeature.MomentPoster,
  StoreFeature.PosterStudio,
  StoreFeature.ErpIntegration,
  StoreFeature.DailyReport,
  StoreFeature.DataReport,
  StoreFeature.MpDataDashboard,
  StoreFeature.Bi,
  StoreFeature.WorkbenchWeb,
  StoreFeature.HubDisplay,
  StoreFeature.AiAssistant,
  StoreFeature.Coaching,
  StoreFeature.VoiceInput,
  StoreFeature.VoiceSynthesis,
]);
